export const CONFIG_MODULE_NAME = '@pressreader/config';
